/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { IsSentoAdmin, usePermissionChecker } from '../../../../app/hooks/PermissionChecker'
import { LIST_PERMISSIONS } from '../../../../app/constants/common'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import moment from 'moment'
import { AsideLinkItem } from './AsideLinkItem'
import { useEffect, useState } from 'react'
import { getContractUrl } from '../../../../app/modules/auth/redux/AuthCRUD'
export function AsideMenuMain() {
  const intl = useIntl()
  const { hasPermission } = usePermissionChecker();
  const Sento = IsSentoAdmin();
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [contractUrl, setContractUrl] = useState<string>('');

  useEffect(() => {
    getContract();
  },[])

  const getContract = async () => {
      const {data} = await getContractUrl();
      setContractUrl(data?.contract_url ?? null);
    }
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {hasPermission(LIST_PERMISSIONS.PRODUCTS) && (
        <>
          <AsideMenuItemWithSub
            to='/products'
            icon='/media/icons/duotune/abstract/abs027.svg'
            title={intl.formatMessage({ id: 'MENU.PRODUCTS' })}
            fontIcon='bi-app-indicator'
          >
            {hasPermission(LIST_PERMISSIONS.PRODUCTS) && (
              <AsideMenuItem
                to='/products/simple'
                title={intl.formatMessage({ id: 'MENU.PRODUCTS' })}
                hasBullet
              />
            )}
            {hasPermission(LIST_PERMISSIONS.COMBO) && (
              <AsideMenuItem
                to='/products/combo'
                title={'Combo sản phẩm'}
                hasBullet
              />
            )}
            {hasPermission(LIST_PERMISSIONS.CONSIGN_PRODUCTS) && (
              <AsideMenuItem
                to='/products/consignment'
                title={'Sản phẩm ký gửi mới'}
                hasBullet
              />
            )}
          </AsideMenuItemWithSub>
          {Sento && (
            <AsideMenuItemWithSub
              to='/products-hub'
              icon='/media/icons/duotune/abstract/abs027.svg'
              title={'Kho dữ liệu SENTO'}
              fontIcon='bi-app-indicator'
            >
              <AsideMenuItem
                to='/products-hub/approved'
                title={'Kho dữ liệu barcode'}
                hasBullet
              />
              <AsideMenuItem
                to='/products-hub/temp'
                title={'Kho dữ liệu tạm'}
                hasBullet
              />
            </AsideMenuItemWithSub>
          )}
        </>
      )}
      {(
        hasPermission(LIST_PERMISSIONS.ORDERS)
        || hasPermission(LIST_PERMISSIONS.PURCHASED_SEARCH)
        || hasPermission(LIST_PERMISSIONS.PRODUCT_SALES_STATISTIC)
      ) && (
        
        <AsideMenuItemWithSub
          to='/orders'
          icon='/media/icons/duotune/ecommerce/ecm006.svg'
          title={intl.formatMessage({ id: 'MENU.ORDER' })}
          fontIcon='bi-app-indicator'
        >
          {hasPermission(LIST_PERMISSIONS.ORDERS) && (
            <AsideMenuItem
              to='/orders'
              title={intl.formatMessage({ id: 'MENU.ORDER' })}
              hasBullet
            />
          )}
          {hasPermission(LIST_PERMISSIONS.ORDERS) && (
            <AsideMenuItem
              to='/orders/bulk-import-invoices'
              title={'Nhập hóa đơn hàng loạt'}
              hasBullet
            />
          )}
          {hasPermission(LIST_PERMISSIONS.PURCHASED_SEARCH) && (
            <AsideMenuItem
              to='/orders/product-search'
              title='Tìm kiếm sản phẩm'
              hasBullet
            />
          )}
          {hasPermission(LIST_PERMISSIONS.PRODUCT_SALES_STATISTIC) && (
            <AsideMenuItem
              to='/orders/product-sale'
              title='Thống kê sản phẩm bán'
              hasBullet
            />
          )}
        </AsideMenuItemWithSub>
      )}
      {hasPermission(LIST_PERMISSIONS.SUPPLIERS) && (
        <AsideMenuItem
          to='/suppliers'
          icon='/media/icons/duotune/abstract/abs027.svg'
          title={intl.formatMessage({ id: 'MENU.SUPPLIERS' })}
          fontIcon='bi-app-indicator'
        />
      )}
      {Sento && (
        <AsideMenuItem
          to='/consigment-suppliers'
          icon='/media/icons/duotune/abstract/abs027.svg'
          title={'Nhà cung cấp ký gửi'}
          fontIcon='bi-app-indicator'
        />
      )}
      {hasPermission(LIST_PERMISSIONS.AGENTS) && (
        <AsideMenuItem
          to='/agents'
          icon='/media/icons/duotune/communication/com005.svg'
          title={intl.formatMessage({ id: 'MENU.AGENT' })}
          fontIcon='bi-app-indicator'
        >

          {/*<AsideMenuItem to='/customer/add' title={intl.formatMessage({id: 'MENU.LIST'})} hasBullet={true}/>*/}
          {/*<AsideMenuItem to='/customer/group' title={intl.formatMessage({id: 'MENU.CUSTOMER_GROUP'})} hasBullet={true}/>*/}
          {/*<AsideMenuItem to='/customer/c' title={intl.formatMessage({id: 'MENU.PRICE_LIST'})} hasBullet={true}/>*/}
        </AsideMenuItem>
      )}
      {(
        hasPermission(LIST_PERMISSIONS.WAREHOUSE)
        || hasPermission(LIST_PERMISSIONS.CARTS)
        || hasPermission(LIST_PERMISSIONS.WARRANTY_REFUND)
        || hasPermission(LIST_PERMISSIONS.RECEIPT_IN)
        || hasPermission(LIST_PERMISSIONS.CREATE_RECEIPT_BY_IMG)
        || hasPermission(LIST_PERMISSIONS.FIND_PD_IN_RECEIPTS)
        || hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST)
        || hasPermission(LIST_PERMISSIONS.RECEIPT_OUT)
      ) && (
        <AsideMenuItemWithSub
          to='/warehouse'
          icon='/media/icons/duotune/ecommerce/ecm009.svg'
          title={intl.formatMessage({ id: 'MENU.WAREHOUSE_MANAGEMENT' })}
          fontIcon='bi-app-indicator'
        >
          {hasPermission(LIST_PERMISSIONS.CARTS) && (
            <AsideMenuItem to='/warehouse/cart' 
              title={intl.formatMessage({ id: 'MENU.CART' })} 
              icon='/media/icons/duotune/ecommerce/ecm001.svg'
            />
          )}
          {hasPermission(LIST_PERMISSIONS.WARRANTY_REFUND) && (
            <AsideMenuItem to='/warehouse/warranty_refund' 
              title={intl.formatMessage({ id: 'MENU.WARRANTY_REFUND' })}
              icon='/media/icons/duotune/arrows/arr031.svg'/>
          )}
          {hasPermission(LIST_PERMISSIONS.WAREHOUSE) && (
            <AsideMenuItem 
              to='/warehouse/list' 
              title={intl.formatMessage({ id: 'MENU.WAREHOUSE' })} 
              icon='/media/icons/duotune/general/gen017.svg'/>
          )}
          {(
            hasPermission(LIST_PERMISSIONS.RECEIPT_IN)
            || hasPermission(LIST_PERMISSIONS.CREATE_RECEIPT_BY_IMG)
            || hasPermission(LIST_PERMISSIONS.FIND_PD_IN_RECEIPTS)
            || hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST)
          ) && (
            <AsideMenuItemWithSub
              to='/warehouse/receipt'
              icon='/media/icons/duotune/arrows/arr076.svg'
              title="Đơn nhập hàng"
              fontIcon='bi-app-indicator'
            >
              {hasPermission(LIST_PERMISSIONS.CREATE_RECEIPT_BY_IMG) && (
                <AsideMenuItem to='/warehouse/receipt/create-by-image' title={'Tạo đơn nhập bằng ảnh'} hasBullet />
              )}
              <AsideMenuItem
                to='/warehouse/receipt/bulk-import-invoices'
                title={'Nhập hóa đơn hàng loạt'}
                hasBullet
              />
              {hasPermission(LIST_PERMISSIONS.RECEIPT_IN) && (
                <AsideMenuItem to='/warehouse/receipt/list' title={intl.formatMessage({ id: 'MENU.RECEIPT' })} hasBullet />
              )}
              {hasPermission(LIST_PERMISSIONS.FIND_PD_IN_RECEIPTS) && (
                <AsideMenuItem to='/warehouse/receipt/find-products' title={'Tìm kiếm sản phẩm'} hasBullet />
              )}
              {(!Sento && hasPermission(LIST_PERMISSIONS.IMPORT_REQUEST)) && (
                <AsideMenuItem to='/warehouse/receipt/import-requests' title={'Nhập hàng ký gửi'} hasBullet />
              )}
            </AsideMenuItemWithSub>
          )}
          {hasPermission(LIST_PERMISSIONS.RECEIPT_OUT) && (
            <AsideMenuItemWithSub
              to='/warehouse/inventory-delivery'
              icon='/media/icons/duotune/arrows/arr077.svg'
              title="Đơn xuất hàng"
              fontIcon='bi-app-indicator'
            >
              <AsideMenuItem to='/warehouse/inventory-delivery/list' title={'Đơn hàng xuất kho'} hasBullet />
              <AsideMenuItem to='/warehouse/inventory-delivery/find-products' title={'Tìm kiếm sản phẩm'} hasBullet />
            </AsideMenuItemWithSub>
          )}
          {hasPermission(LIST_PERMISSIONS.WAREHOUSE) && (
            <AsideMenuItem 
              to='/warehouse/inventory-check-sheet' 
              title={intl.formatMessage({ id: 'MENU.INVENTORY_CHECK_SHEET' })}
              icon='/media/icons/duotune/files/fil008.svg' />
          )}
          {hasPermission(LIST_PERMISSIONS.IMPORT_OPEN_STOCK) && (
            <AsideMenuItem 
              to='/warehouse/import-opening-stocks' 
              title={'Nhập tồn đầu kỳ'}
              icon='/media/icons/duotune/files/fil002.svg' />
          )}
        </AsideMenuItemWithSub>
      )}
      {hasPermission(LIST_PERMISSIONS.ABILITIES) && (
        <AsideMenuItemWithSub
          to='/abilities'
          icon='/media/icons/duotune/finance/fin002.svg'
          title={intl.formatMessage({ id: 'MENU.ABILITIES' })}
          fontIcon='bi-app-indicator'
        >
          {hasPermission(LIST_PERMISSIONS.RECIEPT_VOUCHER) && (
            <AsideMenuItem to='/abilities/receipt-voucher' title={intl.formatMessage({ id: 'MENU.RECEIPT_VOUCHER' })} hasBullet />
          )}
          {hasPermission(LIST_PERMISSIONS.PAYMENT_VOUCHER) && (
            <AsideMenuItem to='/abilities/payment-voucher' title={intl.formatMessage({ id: 'MENU.PAYMENT_VOUCHER' })} hasBullet />
          )}
          {hasPermission(LIST_PERMISSIONS.PAYMENT_REQUEST) && (
            <AsideMenuItem to='/abilities/payment-request' title={'Yêu cầu thanh toán'} hasBullet />
          )}
          {hasPermission(LIST_PERMISSIONS.CASH_BANK_BOOK) && (
            <AsideMenuItem to='/abilities/index' title={intl.formatMessage({ id: 'MENU.ABILITIES' })} hasBullet />
          )}
        </AsideMenuItemWithSub>
      )}
      {Sento && (
        <AsideMenuItem
          to='/consigment-sales'
          icon='/media/icons/duotune/abstract/abs027.svg'
          title={'Sản phẩm ký gửi đã bán'}
          fontIcon='bi-app-indicator'
        />
      )}
      {(
        hasPermission(LIST_PERMISSIONS.DEBTS)
        || hasPermission(LIST_PERMISSIONS.AGENT_DEBT)
        || hasPermission(LIST_PERMISSIONS.SUPPLIER_DEBT)
      ) && (
        <>
          <AsideMenuItemWithSub
            to='/debt'
            icon='\media\icons\duotune\finance\fin010.svg'
            title={intl.formatMessage({ id: 'MENU.DEBT' })}
            fontIcon='bi-app-indicator'
          >
            {hasPermission(LIST_PERMISSIONS.AGENT_DEBT) && (
              <AsideMenuItem to='/debt/agency' title={intl.formatMessage({ id: 'MENU.DEBT.AGENCY' })} icon='\media\icons\duotune\general\gen001.svg' />
            )}
            {hasPermission(LIST_PERMISSIONS.SUPPLIER_DEBT) && (
              <AsideMenuItem to='/debt/supplier' title={intl.formatMessage({ id: 'MENU.DEBT.SUPPLIER' })} icon='\media\icons\duotune\ecommerce\ecm006.svg' />
            )}
          </AsideMenuItemWithSub>
          
        </>
      )}
      {hasPermission(LIST_PERMISSIONS.SALES) && (
        <AsideMenuItem
          to='/sales-report'
          icon='\media\icons\duotune\finance\fin010.svg'
          title={'Báo cáo doanh thu'}
          fontIcon='bi-app-indicator'
        />
      )}
      {(
        hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_BANK)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_CASH)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_SALE)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_EXPENSE)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_WAREHOUSE)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_TAX)
        || hasPermission(LIST_PERMISSIONS.ACCOUNT_BOOKS_PAYROLL)
      ) && (
      <AsideMenuItemWithSub
        to='/account-books'
        icon='/media/icons/duotune/finance/fin006.svg'
        title={'Báo cáo thuế'}
        fontIcon='bi-app-indicator'
      >
        <AsideMenuItem to='/account-books/index' title={'Sổ sách báo cáo'} icon='\media\icons\duotune\communication\com005.svg' />
        <AsideMenuItem to='/account-books/reconcile' title={'Đối soát hóa đơn'} icon='\media\icons\duotune\ecommerce\ecm008.svg' />
        <AsideMenuItem to='/account-books/bank-reconcile' title={'Đối soát ngân hàng'} icon='\media\icons\duotune\finance\fin001.svg' />
        {Sento && (
          <AsideMenuItem to='/account-books/mst-tax-groups' title={'Nhóm ngành'} icon='\media\icons\duotune\coding\cod001.svg' />
        )}
      </AsideMenuItemWithSub>
      )}
      {(hasPermission(LIST_PERMISSIONS.ACCOUNTS)) && (
        <>
          <AsideMenuItemWithSub
            to='/accounts'
            icon='/media/icons/duotune/general/gen051.svg'
            title={intl.formatMessage({ id: 'MENU.ACCOUNT' })}
            fontIcon='bi-app-indicator'
          >
            <AsideMenuItem to='/accounts/list' title={intl.formatMessage({ id: 'MENU.ACCOUNT.LIST' })} icon='\media\icons\duotune\communication\com005.svg' />
            {Sento && (
              <AsideMenuItem to='/accounts/roles' title={intl.formatMessage({ id: 'MENU.ROLE.LIST' })} icon='\media\icons\duotune\coding\cod001.svg' />
            )}
          </AsideMenuItemWithSub>
          {Sento && (
            <AsideMenuItem
              to='/accountance-users'
              icon='/media/icons/duotune/communication/com005.svg'
              title={'Tài khoản kế toán'}
              fontIcon='bi-app-indicator'
            />
          )}
        </>
      )}
      {(hasPermission(LIST_PERMISSIONS.STORES) && Sento) && (
        <AsideMenuItem
          to='/stores'
          icon='/media/icons/duotune/ecommerce/ecm004.svg'
          title={intl.formatMessage({ id: 'MENU.STORE' })}
          fontIcon='bi-app-indicator'
        />
      )}
      {/* <AsideMenuItem
        to='/printers'
        icon='/media/icons/duotune/general/printer-icon.svg'
        title={"Thiết lập máy in"}
        fontIcon='bi-app-indicator'
      /> */}
      {(hasPermission(LIST_PERMISSIONS.ACCOUNTS) && Sento )&& (
        <AsideMenuItem
          to='/auth-logs'
          icon='/media/icons/duotune/ecommerce/ecm004.svg'
          title='Lịch sử đăng nhập'
          fontIcon='bi-app-indicator'
        />
      )}
      {(!Sento && user?.store)&& (
        <>
          <AsideMenuItemWithSub
            to='/purchase'
            icon='/media/icons/duotune/general/gen013.svg'
            title={'Thời hạn sử dụng'}
            fontIcon='bi-app-indicator'
          >
            <AsideMenuItem
              to='/my-account'
              icon='/media/icons/duotune/general/gen013.svg'
              title={'Đăng ký: ' + moment(user?.store?.created_at).format('DD-MM-YYYY')}
              fontIcon='bi-app-indicator'
            />
            <AsideMenuItem
              to='/my-account'
              icon='/media/icons/duotune/general/gen013.svg'
              title={'Hết hạn: ' + moment(user?.store?.expired_at).format('DD-MM-YYYY')}
              fontIcon='bi-app-indicator'
            />
          </AsideMenuItemWithSub>
          <AsideMenuItemWithSub
            to='/purchase'
            icon='/media/icons/duotune/general/gen017.svg'
            title={'Dịch vụ & Hợp đồng'}
            fontIcon='bi-app-indicator'
          >
            <AsideMenuItemWithSub
              to='/purchase'
              icon='/media/icons/duotune/general/gen017.svg'
              title={'Gia hạn phần mềm'}
              fontIcon='bi-app-indicator'
            >
              <AsideLinkItem to='https://aff.sento.vn/product/goi-co-ban/41' title={'Gia hạn gói Cơ bản'} icon='\media\icons\duotune\coding\cod001.svg' />
              <AsideLinkItem to='https://aff.sento.vn/product/goi-nang-cao/42' title={'Gia hạn gói Nâng cao'} icon='\media\icons\duotune\coding\cod001.svg' />
              <AsideLinkItem to='https://aff.sento.vn/product/goi-tieu-chuan/43' title={'Gia hạn gói Tiêu chuẩn'} icon='\media\icons\duotune\coding\cod001.svg' />
              <AsideLinkItem to='https://aff.sento.vn/product/goi-toan-dien/44' title={'Gia hạn gói Toàn diện'} icon='\media\icons\duotune\coding\cod001.svg' />
            </AsideMenuItemWithSub>
            <AsideMenuItemWithSub
              to='/purchase'
              icon='/media/icons/duotune/files/fil025.svg'
              title={'Hợp đồng điện tử'}
              fontIcon='bi-app-indicator'
            >
              <AsideLinkItem to='https://drive.google.com/file/d/1GbX3BI8LAEzWiy-T5e4IzFUOOHtmAkrU' title={'Hợp đồng CTV'} icon='\media\icons\duotune\coding\cod001.svg' />
              <AsideLinkItem to='https://drive.google.com/file/d/1aIah476EZYwPdPhzA9_FH3hxR6K-t1tQ' title={'Hợp đồng phần mềm'} icon='\media\icons\duotune\coding\cod001.svg' />
              {contractUrl && contractUrl !== null && (
                <AsideLinkItem to={contractUrl} title={'Hợp đồng đã ký'} icon='\media\icons\duotune\coding\cod001.svg' />
              )}
            </AsideMenuItemWithSub>
            <AsideLinkItem to='https://sento-tim-doi-tac-ke-toan.nguyensontri.chatgpt.site' title={'Đối tác kế toán'} icon='\media\icons\duotune\general\gen049.svg' />
          </AsideMenuItemWithSub>
        </>
      )}
    </>
  )
}
